// extracted by mini-css-extract-plugin
export default {"publicCatalogLink":"publicCatalogLink---o4r6U","notPublic":"notPublic---PImlk"};